import React from 'react'
import Image from '../../../images/sellerpolicies/18.png'

const Seller_information = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Seller information:</h2>
            <p>Sellers are not allowed to share their personal contact details anywhere in the SKU i-e in SKU images with personal contact details of seller, contact number in product title, highlights or description.</p>
        </div>
      </div>
    </div>
  )
}

export default Seller_information
